"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureLocales = void 0;
const api_1 = require("primereact/api");
const configureLocales = (language) => {
    console.log('Registrando locales para:', language);
    if (typeof api_1.addLocale !== 'function') {
        console.error('⚠️ PrimeReact no está cargado correctamente.');
        return;
    }
    const locales = {
        'es-ES': {
            firstDayOfWeek: 1,
            dayNames: [
                'domingo',
                'lunes',
                'martes',
                'miércoles',
                'jueves',
                'viernes',
                'sábado',
            ],
            dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
            dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
            monthNames: [
                'Enero',
                'Febrero',
                'Marzo',
                'Abril',
                'Mayo',
                'Junio',
                'Julio',
                'Agosto',
                'Septiembre',
                'Octubre',
                'Noviembre',
                'Diciembre',
            ],
            monthNamesShort: [
                'Ene',
                'Feb',
                'Mar',
                'Abr',
                'May',
                'Jun',
                'Jul',
                'Ago',
                'Sep',
                'Oct',
                'Nov',
                'Dic',
            ],
            today: 'Hoy',
            clear: 'Limpiar',
            emptyMessage: 'No hay resultados',
        },
        'en-US': {
            firstDayOfWeek: 0,
            dayNames: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
            ],
            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
            monthNames: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ],
            monthNamesShort: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ],
            today: 'Today',
            clear: 'Clear',
            emptyMessage: 'No results found',
        },
    };
    Object.entries(locales).forEach(([key, value]) => {
        (0, api_1.addLocale)(key, value);
    });
    const selectedLocale = language.startsWith('es') ? 'es-ES' : 'en-US';
    (0, api_1.locale)(selectedLocale);
    console.log('Locales disponibles:', Object.keys(locales));
    console.log('Locale seleccionado:', selectedLocale);
};
exports.configureLocales = configureLocales;
